import type { ApiError } from "@alfabetizando/contracts";

export const ADMIN_REAUTH_REQUIRED = "ADMIN_REAUTH_REQUIRED";

export class AdminApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly correlationId: string | null;
  readonly fieldErrors: Readonly<Record<string, readonly string[]>>;

  constructor(status: number, error: ApiError) {
    super(error.message);
    this.name = "AdminApiError";
    this.status = status;
    this.code = error.code;
    this.correlationId = error.correlationId;
    this.fieldErrors = error.fieldErrors;
  }
}

export function isAdminApiError(error: unknown): error is AdminApiError {
  return error instanceof AdminApiError;
}

export function adminErrorMessage(error: unknown, fallback = "Não foi possível concluir a operação administrativa."): string {
  return isAdminApiError(error) || error instanceof Error ? error.message : fallback;
}
